export const removeAcento = function (string) {
  if (!string) return "";
  return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
